import React from 'react';
import { ICONS } from 'constants/icons';
import { MANAGE_SERVICES_TAB } from 'constants/logic';
import EmptyState from '../../EmptyState';
import { messages } from '../Resources.messages';

const ResourcesEmpty = () => (
  <EmptyState
    headerMessage={messages.empty.header}
    subheaderMessage={messages.empty.subheader}
    buttonMessage={messages.empty.button}
    tab={MANAGE_SERVICES_TAB.RESOURCES}
    iconSource={ICONS.resourcesEmpty}
    iconTitleMessage={messages.empty.emptyIcon}
  />
);

export default ResourcesEmpty;
